import React, { AnchorHTMLAttributes, HTMLAttributes } from 'react';

interface DivProps extends HTMLAttributes<HTMLDivElement> {}
interface AnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {}

type DivOrAnchorProps = (DivProps | AnchorProps) & { isAnchor?: boolean };

const DivOrAnchor: React.FC<DivOrAnchorProps> = ({
  isAnchor,
  children,
  ...rest
}) =>
  isAnchor ? (
    <a {...(rest as AnchorProps)}>{children}</a>
  ) : (
    <div {...(rest as DivProps)}>{children}</div>
  );

export default DivOrAnchor;
